// Go back and grab the last commit before 4/17/2026 to get the last working version of this code.
import React, { useState } from 'react'
import { getOrCreateIapUserId } from './iapUserId'

export default function SubscribeButton({
	userId,
	className,
	productId,
	buttonText = 'Subscribe',
	subText = '',
	featured = false,
}) {
	//alert('[SUBSCRIBE BUTTON] productId: ', productId)

	const [busy, setBusy] = useState(false)
	const [msg, setMsg] = useState('')

	const effectiveUserId = userId || getOrCreateIapUserId()
	const inApp = typeof window !== 'undefined' && !!window.executeWhenAppReady

	const goHome = () => {
		const target = '/'
		try {
			window.history.replaceState(null, '', target)
		} catch {}
		window.location.assign(target)
	}

	const handleSubscribe = () => {
		setMsg('')

		if (!productId) {
			setMsg('Missing product ID.')
			return
		}

		if (!inApp) {
			setMsg('This purchase is only available in the iOS app.')
			return
		}

		setBusy(true)

		window.executeWhenAppReady(async () => {
			const uid = effectiveUserId

			const exitPaywall = (status) => {
				try {
					if (
						typeof window.isInCustomTab === 'function' &&
						window.isInCustomTab() &&
						typeof window.closeCustomTab === 'function'
					) {
						window.closeCustomTab({
							event: 'iap_complete',
							status: status || 'unknown',
						})
						return
					}
				} catch {}
				goHome()
			}

			try {
				if (typeof window.makeInAppPurchase !== 'function') {
					setMsg(
						'Purchase bridge not ready yet. Force-close and reopen the app, then try again.',
					)
					return
				}

				setMsg('Verifying…')

				const timeoutMs = 8000
				const timeoutPromise = new Promise((resolve) =>
					setTimeout(() => resolve({ status: 'timeout' }), timeoutMs),
				)

				//alert(`[IAP FRONTEND] purchasing productId: ${productId}`)

				const purchasePromise = window.makeInAppPurchase(productId, false, uid)

				const resp = await Promise.race([purchasePromise, timeoutPromise])
				//alert(`[IAP FRONTEND] purchase resp: ${JSON.stringify(resp)}`)

				const status = (resp && resp.status) || resp
				/* alert(
					`[IAP FRONTEND] purchase status: ${(resp && resp.status) || resp}`,
				) */

				if (status === 'timeout') {
					setMsg('Purchase is taking longer than expected. Refreshing…')

					setTimeout(() => {
						window.location.reload()
					}, 600)

					return
				}

				if (status === 'cancelled' || status === 'canceled') {
					setMsg('Purchase cancelled.')
					return
				}

				if (status === 'failed' || status === 'error') {
					setMsg('Purchase failed. Please try again.')
					return
				}

				exitPaywall(status)
			} catch (e) {
				console.error('Purchase error:', e)

				const message = e?.message || String(e)

				if (message.toLowerCase().includes('already subscribed')) {
					setMsg('Subscription found. Restoring access…')

					setTimeout(() => {
						window.location.reload()
					}, 600)
					return
				}

				setMsg('Purchase error: ' + message)
			} finally {
				setBusy(false)
			}
		})
	}

	return (
		<div className={className} style={styles.wrap}>
			<button
				onClick={handleSubscribe}
				disabled={busy}
				style={{
					...styles.subscribeBtn,
					...(featured ? styles.featuredBtn : {}),
					opacity: busy ? 0.7 : 1,
				}}
			>
				{busy ? 'Processing…' : buttonText}
			</button>

			{!busy && subText ? <div style={styles.subText}>{subText}</div> : null}

			{msg && <div style={styles.msg}>{msg}</div>}

			{!inApp && !msg && (
				<div style={styles.notInApp}>Available in the iOS app.</div>
			)}
		</div>
	)
}

const styles = {
	wrap: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
	},
	subscribeBtn: {
		padding: '12px 16px',
		borderRadius: 12,
		fontWeight: 700,
		fontSize: 16,
		border: 'none',
		background: '#2f5fd0',
		color: '#fff',
		cursor: 'pointer',
		width: '100%',
		maxWidth: 260,
	},
	featuredBtn: {
		boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
	},
	subText: {
		marginTop: 10,
		fontSize: 13,
		opacity: 0.8,
		textAlign: 'center',
	},
	msg: {
		marginTop: 8,
		fontSize: 12,
		opacity: 0.85,
		textAlign: 'center',
	},
	notInApp: {
		marginTop: 8,
		fontSize: 12,
		opacity: 0.75,
		textAlign: 'center',
	},
}

/* import React, { useState } from 'react'
import { getOrCreateIapUserId } from './iapUserId'

const PRODUCT_ID = 'com.shirey.stats.monthly'

const setAndroidRestoreOverride = () => {
	try {
		localStorage.setItem('androidRestoreOverride', 'true')
	} catch {}
}

export default function SubscribeButton({ userId, className }) {
	const [busy, setBusy] = useState(false)
	const [msg, setMsg] = useState('')

	const effectiveUserId = userId || getOrCreateIapUserId()
	const inApp = typeof window !== 'undefined' && !!window.executeWhenAppReady

	const goHome = () => {
		// choose your landing route
		const target = '/' // or '/statsandstandings'
		try {
			window.history.replaceState(null, '', target)
		} catch {}
		window.location.assign(target)
	}

	const handleSubscribe = () => {
		setMsg('')
		if (!window.executeWhenAppReady) {
			setMsg('This purchase is only available in the iOS app.')
			return
		}

		setBusy(true)

		window.executeWhenAppReady(async () => {
			const uid = effectiveUserId

			const exitPaywall = (status) => {
				// leave paywall no matter what (prevents "Verifying…" hang)
				try {
					if (
						typeof window.isInCustomTab === 'function' &&
						window.isInCustomTab() &&
						typeof window.closeCustomTab === 'function'
					) {
						window.closeCustomTab({
							event: 'iap_complete',
							status: status || 'unknown',
						})
						return
					}
				} catch {}
				goHome()
			}

			try {
				// ✅ IMPORTANT: check again after app is ready
				if (typeof window.makeInAppPurchase !== 'function') {
					setMsg(
						'Purchase bridge not ready yet. Force-close and reopen the app, then try again.',
					)
					return
				}

				setMsg('Verifying…')

				// ✅ Escape hatch: if wrapper never resolves, exit anyway
				const timeoutMs = 8000
				const timeoutPromise = new Promise((resolve) =>
					setTimeout(() => resolve({ status: 'timeout' }), timeoutMs),
				)

				//const uid = effectiveUserId

				// ✅ Call makeInAppPurchase ONE TIME only
				const purchasePromise = window.makeInAppPurchase(PRODUCT_ID, false, uid)

				const resp = await Promise.race([purchasePromise, timeoutPromise])

				// Normalize status across wrapper variations
				const status = (resp && resp.status) || resp

				// If wrapper says cancelled/failed, stay put and show message
				if (status === 'cancelled' || status === 'canceled') {
					setMsg('Purchase cancelled.')
					return
				}
				if (status === 'failed' || status === 'error') {
					setMsg('Purchase failed. Please try again.')
					return
				}

				if (status === 'restored') {
					setAndroidRestoreOverride()
				}

				// completed / restored / verifying / timeout / unknown → exit
				exitPaywall(status)
			} catch (e) {
				console.error('Purchase error:', e)

				const message = e?.message || String(e)

				if (message.toLowerCase().includes('already subscribed')) {
					setMsg('Subscription found. Restoring access…')
					setAndroidRestoreOverride()

					setTimeout(() => {
						window.location.reload()
					}, 600)
					return
				}

				setMsg('Purchase error: ' + (e?.message || String(e)))

				// even on error, you may want to let them escape instead of being stuck
				// exitPaywall('error')
			} finally {
				setBusy(false)
			}
		})
	}
	//

	const handleRestore = () => {
		setMsg('')

		if (!window.executeWhenAppReady) {
			setMsg('Restore is only available in the iOS app.')
			return
		}

		setBusy(true)

		window.executeWhenAppReady(async () => {
			try {
				// ✅ IMPORTANT: re-check the function *after* app is ready
				if (typeof window.restorePurchases !== 'function') {
					setMsg(
						'Restore is not ready yet. Force-close the app and reopen, then try again.',
					)
					return
				}

				setMsg('Restoring purchases…')

				// Some wrappers return undefined here — that's fine.
				await window.restorePurchases(effectiveUserId)
				//console.log('[RESTORE] restorePurchases result:', result)

				setAndroidRestoreOverride()

				// Give StoreKit/server a moment, then re-check entitlement
				setTimeout(() => {
					window.location.reload()
				}, 600)
			} catch (e) {
				console.error('Restore error:', e)
				setMsg('Restore error: ' + (e?.message || String(e)))
			} finally {
				setBusy(false)
			}
		})
	}

	return (
		<div className={className}>
			<button
				onClick={handleSubscribe}
				disabled={busy}
				style={{ padding: '10px 16px', borderRadius: 12, fontWeight: 700 }}
			>
				{busy ? 'Processing…' : 'Subscribe for $1.99/month'}
			</button>

			<button
				onClick={handleRestore}
				disabled={busy || !inApp}
				style={{ marginLeft: 12, padding: '10px 16px', borderRadius: 12 }}
			>
				Restore Access
			</button>

			{msg && (
				<div style={{ marginTop: 8, fontSize: 12, opacity: 0.85 }}>{msg}</div>
			)}

			{!inApp && !msg && (
				<div style={{ marginTop: 8, fontSize: 12, opacity: 0.75 }}>
					Available in the iOS app.
				</div>
			)}
		</div>
	)
}
 */
